
import { defineComponent, ref, computed, markRaw, Ref, watch } from 'vue'
import { useStore, POST_STORE_SYMBOL, PROJECT_STORE_SYMBOL } from '../../store'
// import { useMarkdown } from '../../composables/useMarkdown'

// import marked from "marked"
// import hljs from "highlight.js"

import { useRoute, useRouter } from 'vue-router'
import { IProject } from '../../interfaces/IProject'
import { colorLog } from '../../utils/colorLog'
import { IPost } from '../../interfaces/IPost'
import ProjectSection from './ProjectSection.vue'
import SectionViewer from './SectionViewer.vue'
import { PostStore } from '../../store/post/post.store'
import { ISection } from '../../interfaces/ISection'
import { useModal } from '../../composables/useModal'
import NewSection from '../input/NewSection.vue'
import { ISession, Session } from '../../store/session/session.interface'
import { ProjectStore } from '../../store/project/project.store'

const debug = false;

export default defineComponent({
  name: 'ProjectViewer',
  components: {
    ProjectSection,
    SectionViewer
  },
  props: {
  },
  async setup() {
    const route = useRoute()
    const postStore: PostStore = useStore<PostStore>(POST_STORE_SYMBOL) as PostStore
    const projectStore: ProjectStore = useStore<ProjectStore>(PROJECT_STORE_SYMBOL) as ProjectStore

    const showBody = ref(true)

    const router = useRouter()
    const sectionModal = useModal('new-section')
    // watch after await forbidden

    // if (!postStore.getState().records.loaded) {
    //   await postStore.fetchRecords()
    // }    
    const selectedSection = ref<ISection['name']>()
    // colorLog(JSON.stringify(route.params), 0)
    
    // const projectRef: Ref<IProject> = ref({} as IProject)
    // const projectProm = await postStore.fetchPostsByProject(route.params.name as string)
    // projectRef.value = projectProm
    // const project: IProject = projectRef.value

    const project: IProject = await postStore.fetchPostsByProject(route.params.name as string)
    
    // need to add this call else projectstore used by session is empty 
    // NOTE commenting for now to test
    // so no project to correlate to name
    // await projectStore.fetchRecords()

    const session: ISession = new Session(project.name, project.categoryName, projectStore)
    const categoryName = project.categoryName
    const sectionNames: ISection['name'][] = project.sections.map(p => p.name).concat(['all']);
    const sectionsComputed = computed(() => project.sections.filter(section => {
      return selectedSection.value ? section.name == selectedSection.value : true
    }))
    const setSection = (section: ISection['name']) => {
      selectedSection.value = section == 'all' ? '' : section
    }
    const newSection = () => {
      colorLog("on new section", undefined, debug);
      sectionModal.component.value = markRaw(NewSection)
      sectionModal.showModal()
    }
    const sections = ref(sectionsComputed.value)

    const onUpdatePosts = async () => {
      colorLog('on update posts', undefined, debug)
      const proj: IProject = await postStore.fetchPostsByProject(route.params.name as string)
      sections.value = proj.sections
    }
    // watch after await forbidden

    return {
      showBody,
      categoryName,
      project,
      setSection,
      sectionNames,
      selectedSection,
      sections,
      newSection,
      onUpdatePosts,
      sectionModal,
      component: sectionModal.component
    }
  }
})
